module["exports"] = [
  "NSW",
  "QLD",
  "NT",
  "SA",
  "WA",
  "TAS",
  "ACT",
  "VIC"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_au_ocker/address/state_abbr.js
// module id = 594
// module chunks = 0